import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { author as AuthorPropType } from 'lib/CustomPropTypes';
import { generateElementKey } from 'lib/stringUtils';
import { reduceCSL } from 'lib/arrayUtils';
import Link from 'components/Link';

/**
 * Mapper for multiple authors.
 */
const authorMap = (author) => {
  // Account for different anatomies of the person object in order to reuse
  // <Byline> across multiple parts of the site.
  const person = get(author, 'person', author);
  const name = get(person, 'name', null);
  if (typeof name !== 'string') {
    return null;
  }
  const key = generateElementKey(name);
  const url = get(person, ['url', 'primary'], null);
  const nameTrim = name.trim();
  return url ? (
    <Link key={key} to={url}>
      {nameTrim}
    </Link>
  ) : (
    <span key={key}>{nameTrim}</span>
  );
};

/**
 * The <Byline> Component.
 * @param  {Object} props
 * @param  {Author[]} props.authors
 */
function Byline({ authors }) {
  if (!Array.isArray(authors) || authors.length === 0) {
    return null;
  }
  const children = authors.map(authorMap).reduce(reduceCSL, []);
  return (
    <>
      {children}
    </>
  );
}

Byline.propTypes = {
  authors: PropTypes.arrayOf(
    AuthorPropType,
  ),
};

Byline.defaultProps = {
  authors: null,
};

export { Byline };
